import { isSameOriginUrl } from '@Core/lib/tasks/utils/navigate';
import { router } from '@inertiajs/react';
import axios from 'axios';

import {
  markPagePreviewUrl,
  PAGE_PREVIEW_HEADER,
  PAGE_PREVIEW_HEADER_VALUE,
  PAGE_PREVIEW_QUERY_PARAMETER,
  PAGE_PREVIEW_QUERY_VALUE
} from './pagePreviewUrl';

let isRegistered = false;

function requestUrl(input: RequestInfo | URL): string {
  return input instanceof Request ? input.url : String(input);
}

function isSameDocumentFragment(url: URL): boolean {
  const currentUrl = new URL(window.location.href);

  return (
    url.origin === currentUrl.origin &&
    url.pathname === currentUrl.pathname &&
    url.search === currentUrl.search &&
    url.hash !== ''
  );
}

export function registerPagePreviewRequests(): void {
  if (isRegistered) {
    return;
  }

  isRegistered = true;
  axios.defaults.headers.common[PAGE_PREVIEW_HEADER] = PAGE_PREVIEW_HEADER_VALUE;

  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    if (!isSameOriginUrl(requestUrl(input))) {
      return originalFetch(input, init);
    }

    const headers = new Headers(input instanceof Request ? input.headers : undefined);
    new Headers(init?.headers).forEach((value, name) => headers.set(name, value));
    headers.set(PAGE_PREVIEW_HEADER, PAGE_PREVIEW_HEADER_VALUE);

    return originalFetch(input, { ...init, headers });
  };

  router.on('before', (event) => {
    event.detail.visit.headers = {
      ...event.detail.visit.headers,
      [PAGE_PREVIEW_HEADER]: PAGE_PREVIEW_HEADER_VALUE
    };
  });

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || !(event.target instanceof Element)) {
      return;
    }

    const link = event.target.closest('a[href]');

    if (!(link instanceof HTMLAnchorElement)) {
      return;
    }

    if (link.target.toLowerCase() === '_top') {
      return;
    }

    const url = new URL(link.href, window.location.href);

    if (url.origin !== window.location.origin || isSameDocumentFragment(url)) {
      return;
    }

    const markedUrl = markPagePreviewUrl(url.toString());

    if (markedUrl === url.toString()) {
      return;
    }

    link.href = markedUrl;
  });

  document.addEventListener(
    'submit',
    (event) => {
      if (!(event.target instanceof HTMLFormElement)) {
        return;
      }

      if (!isSameOriginUrl(event.target.action)) {
        return;
      }

      if (event.target.method.toLowerCase() === 'get') {
        const existingMarker = event.target.elements.namedItem(PAGE_PREVIEW_QUERY_PARAMETER);

        if (existingMarker instanceof HTMLInputElement) {
          existingMarker.value = PAGE_PREVIEW_QUERY_VALUE;
        } else {
          const marker = document.createElement('input');
          marker.type = 'hidden';
          marker.name = PAGE_PREVIEW_QUERY_PARAMETER;
          marker.value = PAGE_PREVIEW_QUERY_VALUE;
          event.target.append(marker);
        }
      } else {
        event.target.action = markPagePreviewUrl(event.target.action);
      }
    },
    { capture: true }
  );
}
